// extracted by mini-css-extract-plugin
module.exports = {"reportInfoContainer":"ReportInfoItem_reportInfoContainer__timvP","item":"ReportInfoItem_item__2FQu6","divider":"ReportInfoItem_divider__TrIFO"};